import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { efficiencyPctFromRatio, efficiencyClassFromRatio } from '../formatters/detail-formatters'

/**
 * Renders an efficiency percentage from a variance ratio (`actual / standard`).
 * 100% = on target. <100% = behind. >100% = ahead. Selector kept as
 * `app-variance-pill` to avoid churn at every callsite — the underlying
 * input is still a variance ratio, just displayed as efficiency.
 */
@Component({
    selector: 'app-variance-pill',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ng-container *ngIf="pct() as p; else dash">
            <span [class]="cls()" data-testid="variance-pct">
                <strong>{{ p }}%</strong>
                <i *ngIf="p < 90"
                   class="fa fa-exclamation-triangle warn-icon"
                   title="Below 90% efficiency (touch exceeds standard)"></i>
            </span>
        </ng-container>
        <ng-template #dash>
            <span class="variance-unknown">—</span>
        </ng-template>
    `,
    styles: [`
        :host { display: inline-flex; align-items: center; gap: .25rem; font-variant-numeric: tabular-nums; }
        .variance-over   { color: #b42318; }
        .variance-under  { color: #b54708; }
        .variance-ok     { color: #027a48; }
        .variance-unknown { color: #98a2b3; }
        .warn-icon { font-size: .75em; }
    `]
})
export class VariancePillComponent {
    @Input() ratio: number | null = null

    pct(): number | null {
        return efficiencyPctFromRatio(this.ratio)
    }

    cls(): string {
        return efficiencyClassFromRatio(this.ratio)
    }
}
